// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const { featureFlagClient } = require('@trello/feature-flag-client');
const { showFlag } = require('@trello/nachos/experimental');
const Alerts = require('app/scripts/views/lib/alerts');
const l = require('app/scripts/lib/localize');
const rpc = require('app/scripts/network/rpc');
const templates = require('app/scripts/views/internal/templates');

module.exports = function () {
  let showConnectingTimeout = null;

  const showConnectFailed = () => {
    clearTimeout(showConnectingTimeout);
    Alerts.hide('connection');
    const msg = l('alerts.could not connect');
    if (featureFlagClient.get('workflowers.ak-flag', false)) {
      showFlag({
        id: 'connectionDead',
        title: msg,
        appearance: 'error',
        actions: [
          {
            content: l('alerts.reload page'),
            onClick: () => window.location.reload(),
            type: 'button',
          },
        ],
        isUndismissable: true,
      });
      return;
    }
    // Different area for connection dead to make it immune to race conditions
    Alerts.showHtml(
      templates.fill(require('app/scripts/views/templates/connect_failed'), {
        msg,
      }),
      'error',
      'connectionDead',
    );
  };

  rpc.on('connect_failed', showConnectFailed);
  rpc.on('reconnect_failed', showConnectFailed);

  const fxReconn = () => {
    clearTimeout(showConnectingTimeout);
    Alerts.hide('connection');
    return Alerts.hide('connectionDead');
  };
  const fxConn = () => {
    // Only show the "Connecting" alert if we've been disconnected for more
    // than 500ms. This should cut down on it flashing really briefly when you
    // have a flaky internet connection.
    clearTimeout(showConnectingTimeout);
    return (showConnectingTimeout = setTimeout(() => {
      showConnectingTimeout = null;
      if (featureFlagClient.get('workflowers.ak-flag', false)) {
        showFlag({
          id: 'connection',
          title: l('alerts.reconnecting'),
          appearance: 'error',
          isUndismissable: true,
        });
      } else {
        Alerts.show('reconnecting', 'error', 'connection');
      }
    }, 500));
  };

  rpc.on('reconnect', fxReconn);
  return rpc.on('connecting', fxConn);
};
